import axios from 'axios';

export default {
  login: credentials => (
    axios.post(`${process.env.REACT_APP_API_URL}-client/login_check`, credentials)
  ),
  register: data => (
    axios.post(`customers/register`, data)
  ),
  forgot_pwd: email => (
    axios.post(`customers/forgot-password-request`, email)
  ),
  forgot_pwd_token: token => (
    axios.post(`customers/forgot-password-token`, { token: token })
  ),
  reset_password: (data) => (
    axios.post(`customers/forgot-password-reset`, data)
  )
}


// WEBPACK FOOTER //
// ./src/api/auth.js